import React from 'react';

import { useAuth0 } from '@auth0/auth0-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  atoms,
  colors,
  DropdownMenu,
  HStack,
  Text,
} from '@rtkwlf/fenrir-react';
import { faCircle } from '@rtkwlf/pro-solid-svg-icons/faCircle';
import { OnboardingStatus } from '@rtkwlf/rendall';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { UserMenu } from '@packages/components/user-menu/user-menu';
import { useImpersonate } from '@packages/hooks/useImpersonate';
import { useAuthContext } from '@packages/legacy/auth';
import { ACCOUNT_CONTACTS_ROUTE } from 'ae-constants/routes.constants';
import { useRendallOrganization } from 'ae-kernel/organizations/use-rendall-organization';

export const ONBOARDING_ROUTE = 'https://portal.arcticwolf.com/onboarding';

export const DashboardUserMenu: React.FC = () => {
  const { currentOrganization } = useRendallOrganization();
  const isOnboarding =
    currentOrganization?.onboardingStatus === OnboardingStatus.Onboarding;

  const impersonate = useImpersonate();
  const { t } = useTranslation();

  const { user } = useAuth0();
  const { logout } = useAuthContext();

  return (
    <UserMenu isOnboarding={isOnboarding} onLogout={logout} user={user}>
      <>
        {isOnboarding && (
          <DropdownMenu.ExternalLinkItem
            href={ONBOARDING_ROUTE + impersonate}
            data-testid="onboarding-portal-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            <HStack gap="xsmall" position="relative">
              <Text>{t('appBar:userMenu.onboarding')}</Text>
              <FontAwesomeIcon
                icon={faCircle}
                color={`rgb(${colors.icon.danger.secondary})`}
                style={{
                  fontSize: '8px',
                  position: 'absolute',
                  right: '-0.75rem',
                  top: '-0.25rem',
                }}
              />
            </HStack>
          </DropdownMenu.ExternalLinkItem>
        )}

        <DropdownMenu.Item asChild>
          <Link
            to={ACCOUNT_CONTACTS_ROUTE}
            className={atoms({
              textColor: 'body',
              textDecoration: 'none',
              width: 'full',
            })}
          >
            {t('appBar:userMenu.organizationProfile')}
          </Link>
        </DropdownMenu.Item>
      </>
    </UserMenu>
  );
};
